
import debounce from 'lodash/debounce';
import { mmMatches } from '../utils/utils.matchmedia';
import Siema from 'siema';

const 	solutionsExplorer = document.querySelector('.js-solutions-explorer'),
		navTextItems = (solutionsExplorer) ? [...solutionsExplorer.querySelectorAll('.js-text-nav-item')] : null,
		navTextButtons = (solutionsExplorer) ? [...solutionsExplorer.querySelectorAll('.js-text-nav-button')] : null,
		prevButton = (solutionsExplorer) ? solutionsExplorer.querySelector('.js-prev') : null,
		nextButton = (solutionsExplorer) ? solutionsExplorer.querySelector('.js-next') : null,
		toggleContent = (solutionsExplorer) ? [...solutionsExplorer.querySelectorAll('.js-toggle-content-item')] : null,
		desktopContent = (solutionsExplorer) ? [...solutionsExplorer.querySelectorAll('.js-desktop-content-item')] : null,

		numberOfSlides = (navTextItems) ? navTextItems.length : 0;

let 	imagesCarousel, contentCarousel,

		carouselInitialised = false,
		accordionInitialised = false;


function moveContent(from, to) {
	toggleContent.forEach( (item, i) => {
		let content = item.innerHTML;
		desktopContent[i].innerHTML = content;
	});
}

function setCurrentTextNavItem(i) {
	navTextItems.forEach( item => {
		item.classList.remove('is-active');
	});

	navTextItems[i].classList.add('is-active');
}

function getCurrentSlideIndex() {
	let currentIndex;

	navTextItems.forEach( ( item, index ) => {
		if ( item.classList.contains('is-active') ) {
			currentIndex = index;
		}
	});

	return currentIndex;
}

function handlePreviousClick() {
	const 	currentSlideIndex = getCurrentSlideIndex(),
			nextSlideIndex = currentSlideIndex - 1;

	if ( nextSlideIndex > -1 ) {
		imagesCarousel.goTo(nextSlideIndex);
		contentCarousel.goTo(nextSlideIndex);

		setCurrentTextNavItem(nextSlideIndex);
	}
}

function handleNextClick() {
	const 	currentSlideIndex = getCurrentSlideIndex(),
			nextSlideIndex = currentSlideIndex + 1;

	if ( nextSlideIndex < numberOfSlides ) {
		imagesCarousel.goTo(nextSlideIndex);
		contentCarousel.goTo(nextSlideIndex);

		setCurrentTextNavItem(nextSlideIndex);
	}
}

function disableButton(button) {
	if(button) {
		button.classList.add('is-disabled');
		button.disabled = true;
	}
}

function enableButton(button) {
	if(button) {
		button.classList.remove('is-disabled');
		button.disabled = false;
	}
}

function loadNextImage(slide) {
	
	let img;

	if ( slide ) {
		img = slide.querySelector('img');
	}

	if ( img && !img.getAttribute('src') ) {
		img.setAttribute('src', img.getAttribute('data-src'));
	}
}

function initCarousel() {

	imagesCarousel = new Siema({
		selector: solutionsExplorer.querySelector('.js-images'),
		duration: 200,
		easing: 'ease-out',
		perPage: 1,
		startIndex: 0,
		draggable: false,
		multipleDrag: true,
		threshold: 20,
		loop: false,
		onInit: function() {
			loadNextImage(this.innerElements[this.currentSlide + 1]);
		},
		onChange: function() {
			loadNextImage(this.innerElements[this.currentSlide + 1]);
		}
	});

	contentCarousel = new Siema({
		selector: solutionsExplorer.querySelector('.js-content'),
		duration: 200,
		easing: 'ease-out',
		perPage: 1,
		startIndex: 0,
		draggable: false,
		multipleDrag: true,
		threshold: 20,
		loop: false,
		onInit: () => {
			disableButton(prevButton);
		},
		onChange: () => {
			if(contentCarousel.currentSlide > 0) {
				enableButton(prevButton);
			} else {
				disableButton(prevButton);
			}

			if(contentCarousel.currentSlide + 1 == numberOfSlides) {
				disableButton(nextButton);
			} else {
				enableButton(nextButton);
			}
		}
	});

	imagesCarousel.goTo(getCurrentSlideIndex());
	contentCarousel.goTo(getCurrentSlideIndex());

	prevButton.addEventListener('click', handlePreviousClick);
	nextButton.addEventListener('click', handleNextClick);
}

function destroyCarousel() {

	if ( imagesCarousel ) {
		imagesCarousel.destroy(true);
	}

	if ( imagesCarousel ) {
		contentCarousel.destroy(true);
	}

	prevButton.removeEventListener('click', handlePreviousClick);
	nextButton.removeEventListener('click', handleNextClick);
}


if ( solutionsExplorer ) {

	navTextButtons.forEach( (item, i) => {
		item.addEventListener('click', (e) => {

			if ( mmMatches('desktop') ) {
				imagesCarousel.goTo(i);
				contentCarousel.goTo(i);
			}

			setCurrentTextNavItem(i);
		});
	});

	function setBehaviour() {

		if ( mmMatches('desktop') ) {

			if ( !carouselInitialised ) {
				initCarousel();

				carouselInitialised = true;
				accordionInitialised = false;
			}

		} else {

			if ( !accordionInitialised ) {
				destroyCarousel();

				accordionInitialised = true;
				carouselInitialised = false;
			}
		}
	}

	moveContent();
	setBehaviour();
	window.addEventListener('resize', debounce(setBehaviour, 150));
}


